var hero_slider = (function ( $ ) {

	var $carousel = null;

	var _init = function () {
		$carousel = $( '#fp-hero-slider' ).find( '.owl-carousel' );

		_setup_slider();
	};

	var _setup_slider = function () {
		$carousel.on( 'initialized.owl.carousel', _slider_initialised );

		var icons_dir = ScriptData.theme_uri + '/assets/icons';

		$carousel.owlCarousel( {
			items: 1,
			loop: true,
			nav: true,
			navText: [
				'<img class="prev" src="' + icons_dir + '/arrow-left-white-1.svg" />',
				'<img class="next" src="' + icons_dir + '/arrow-right-white-1.svg" />'
			],
			dots: false,
			autoplay: false
		} );

		$('.owl-controls').addClass('container');
	};

	var _slider_initialised = function( event ) {
		$carousel.find( '.owl-item .item' ).show();
	};

	if ( $( '#fp-hero-slider' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = hero_slider;